require('./bootstrap-4');
import App from "./components/Game/App";

window.Vue = require('vue');

const files = require.context('./components/Game/', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

const app = new Vue(App).$mount('#game');
